import React from "react";
import { Image, Carousel } from "react-bootstrap";

function ImageGallery(props) {
  const getImageAlt = (image) => {
    if (image.translations && image.translations.length) {
      return image.translations[0].imageDescription;
    }
    if (props.product.translations && props.product.translations.length) {
      const lang = new URLSearchParams(window.location.search).get("lang") || "eng";
      const translation = props.product?.translations.find((t) => t?.languageIsoCode === lang);
      if (translation) {
        return translation.productName;
      }
    }
    return "";
  }
  const getImageTitle = (image) => {
    if (image.translations && image.translations.length) {
      return image.translations[0].imageTitle;
    }
    return "";
  }
  return (
    <Carousel controls={false} indicators={false} interval={null} className={props?.images?.length === 1 ? "single-img" : ""}>
      {props.images?.map((img, i) => {
        return (
          <Carousel.Item key={i}  >
            <Image className="product-img" role="presentation" src={img.fullURL} title={getImageTitle(img)} alt={getImageAlt(img)} fluid />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );

}

export default ImageGallery;
